export default "__VITE_ASSET__DoSPt_XB__"